import { Dexie } from 'dexie'
import { applyEncryptionMiddleware, ENCRYPT_LIST } from 'dexie-encrypted'

// Helper: must be applied before .version() call
const reorderDexieEncrypted = (db: Dexie) => {
  // @ts-ignore
  const mw = db._middlewares.dbcore.find((mw) => mw.name === 'encryption')
  if (!mw) throw new Error('Dexie encrypted not applied')

  db.use({
    name: 'encryption',
    stack: 'dbcore',
    level: 2, // Above sync layer (level 1)
    create: mw.create,
  })
}

// Helper when the key changes
const onEncKeyChange = async (p: any) => {
  console.log('Encryption key changed', p)
}

// Helper to convert Base64 string to Uint8Array
const base64ToUint8Array = (base64: string): Uint8Array => {
  const binaryString = atob(base64)
  const len = binaryString.length
  if (len !== 32)
    throw new Error('Encryption key must be 32 bytes (44 characters in Base64)')

  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}

export const applyEncryption = (db: Dexie) => {
  const encConfig = {
    users: {
      type: ENCRYPT_LIST,
      fields: [
        'address',
        'phone',
        'dob',
        'email',
        'emergencyName',
        'emergencyPhone',
        'emergencyName1',
        'emergencyPhone1',
        'password',
        'medicalConditions',
      ],
    },
  }
  const rawKey = import.meta.env.VITE_ENCRYPTION_KEY
  if (!rawKey) throw new Error('Encryption key not defined')
  const encryptionKey = base64ToUint8Array(rawKey)
  // @ts-ignore - the types of the encConfig
  applyEncryptionMiddleware(db, encryptionKey, encConfig, onEncKeyChange)
  reorderDexieEncrypted(db)
}
